// material-ui
import { createTheme } from '@mui/material/styles';

// third-party
import { presetPalettes } from '@ant-design/colors';

// project import
import ThemeOption from './theme';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode) => {
    const colors = presetPalettes;

    const greyPrimary = [
        '#ffffff',
        '#fafafa',
        '#f5f5f5',
        '#f0f0f0',
        '#d9d9d9',
        '#bfbfbf',
        '#8c8c8c',
        '#595959',
        '#262626',
        '#141414',
        '#000000'
    ];
    const greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
    const greyConstant = ['#fafafb', '#e6ebf1'];

    colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

    const paletteColor = ThemeOption(colors);

    return createTheme({
        palette: {
            mode,
            common: {
                black: '#000',
                white: '#fff'
            },
            ...paletteColor,
            // Override `error` / `warning` so destructive UI (void modal, delete CTAs,
            // status pills via `palette.error.main`) matches the Figma design tokens
            // (`Text_color/Error/Default = #f43f5e`, `Text_color/Warning/Default = #ee8316`).
            // We keep antd-derived `lighter`/`dark`/`darker` (consumed by overrides/Chip.js)
            // intact by spreading the existing palette entries first.
            error: {
                ...paletteColor.error,
                main: '#f43f5e',
                light: '#feecef',
                contrastText: '#fff'
            },
            warning: {
                ...paletteColor.warning,
                main: '#ee8316',
                light: '#fef5e7',
                contrastText: '#fff'
            },
            text: {
                primary: paletteColor.grey[700],
                secondary: paletteColor.grey[500],
                disabled: paletteColor.grey[400]
            },
            action: {
                disabled: paletteColor.grey[300]
            },
            divider: paletteColor.grey[200],
            background: {
                paper: paletteColor.grey[0],
                default: paletteColor.grey.A50
            }
        }
    });
};

export default Palette;
